module.exports = "/_next/static/images/SingleSourceOfTruth-1b3783c0c28fd8ba0bb757d575b48829.webp";